module.exports = __webpack_public_path__ + "media/images/lb/736-b7df6196ce1747a86c766a14349375d2.svg";